module.exports = __webpack_public_path__ + "static/szenario3_1-11d3fc7f5aa1d4467bf1f077fe7e9646.png";